import { generateTranslationKey } from '../../utils/convert.util';
import Translations from '../Translations';
import React, {useState} from 'react';
import {Icon} from 'semantic-ui-react';
import HELPER_FUNCTION_UTILITY from '../../utils/helper';
import {calculatePaymentBreakdown, normalizePaymentMethod, PAYMENT_METHOD} from '../../utils/payment';
import {formatAmountWithCurrency} from '../../utils/currency';

const PaymentSummary = ({total, startingBalance, paymentMethod, currencyMinorUnit, currency, products, coverages, leaveBarter, walletOnly = false}) => {
    const [showItemDetails, setShowItemDetails] = useState(false);
    const method = normalizePaymentMethod(paymentMethod);
    const breakdown = calculatePaymentBreakdown(total, startingBalance, method);
    const format = (amount) => HELPER_FUNCTION_UTILITY.numberWithCommas(Math.abs(amount), currencyMinorUnit);
    const amountWithCurrency = (amount, sign = '') => formatAmountWithCurrency(format(amount), currency, sign);
    const deduction = (amount) => amountWithCurrency(amount, amount < 0 ? '+ ' : amount > 0 ? '- ' : '');
    const rows = [];
    const itemDetails = Object.keys(products || {}).map((productKey) => {
        const amount = Object.keys(coverages || {}).reduce((productTotal, memberId) => {
            const coverage = coverages[memberId]?.[productKey];
            const option = HELPER_FUNCTION_UTILITY.getSelectedCoverageOption(
                coverage?.options || [],
                coverage?.selectOption?.id,
            );
            return productTotal + (option?.price || 0);
        }, 0);

        return {key: productKey, name: products[productKey].name, translationKey: `insurance_product.${generateTranslationKey(products[productKey].name)}`, amount};
    });

    if (leaveBarter?.enableDeduction && leaveBarter.choice) {
        itemDetails.push({key: 'leave-options', name: 'Leave Options', translationKey: 'selection.leave options', amount: leaveBarter.choice.price * -1});
    }

    if (walletOnly) {
        const balance = startingBalance - total;
        rows.push(['walletbalancewidget.walletbalance', 'Wallet Balance', amountWithCurrency(balance, balance > 0 ? '+' : balance < 0 ? '-' : ''), true]);
    } else if (method === PAYMENT_METHOD.SALARY_DEDUCTION && total >= 0) {
        rows.push(['selection.payment_method_salary', 'Salary Deduction', deduction(breakdown.salaryDeduction), true]);
    } else {
        rows.push(['selection.payment_method_flex_wallet_starting_amount', 'Flex Wallet Starting Amount', amountWithCurrency(startingBalance), true]);
        rows.push(['selection.payment_method_flex_wallet', 'Flex Wallet Deduction', deduction(breakdown.walletDeduction), true]);
        if (method === PAYMENT_METHOD.FLEX_WALLET_DEDUCTION && breakdown.salaryDeduction !== 0) {
            rows.push(['selection.payment_method_salary', 'Salary Deduction', deduction(breakdown.salaryDeduction), true]);
        }
        rows.push(['selection.payment_method_flex_wallet_balance', 'Flex Wallet Balance', amountWithCurrency(breakdown.walletBalance), true]);
    }

    return (
        <div className="footer payment-summary">
            <div className="payment-summary-total">
                <div className="payment-summary-total-label">
                    <span><Translations text="selection.cart_item3" backup={"Cart Total"} /></span>
                    <Translations
                        text={showItemDetails ? 'selection.hide_item_details' : 'selection.show_item_details'}
                        backup={showItemDetails ? 'Hide item details' : 'Show item details'}
                        render={label => (
                    <button
                        type="button"
                        className="payment-summary-details-toggle"
                        aria-label={label}
                        aria-expanded={showItemDetails}
                        onClick={() => setShowItemDetails(!showItemDetails)}
                    >
                        <Icon name={showItemDetails ? 'angle up' : 'angle down'} />
                    </button>
                        )}
                    />
                </div>
                <strong>{walletOnly ? amountWithCurrency(total, total > 0 ? '-' : total < 0 ? '+' : '') : deduction(total)}</strong>
            </div>
            {showItemDetails && (
                <div className="payment-summary-details">
                    {itemDetails.map((item) => (
                        <div className="payment-summary-detail" key={item.key}>
                            <span><Translations text={item.translationKey} backup={item.name} /></span>
                            <strong>{deduction(item.amount)}</strong>
                        </div>
                    ))}
                </div>
            )}
            {rows.map(([translationKey, label, amount, emphasized]) => (
                <div className={`payment-summary-row ${emphasized ? 'emphasized' : ''}`} key={translationKey}>
                    <span><Translations text={translationKey} backup={label} /></span><span>{amount}</span>
                </div>
            ))}
        </div>
    );
};

export default PaymentSummary;
